/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.provider', [])
    .factory('providerService', ProviderService)
    .name;

/*@ngInject*/
function ProviderService($http, $q) {

    var service = {
        deleteProvider: deleteProvider,
        getProvider: getProvider,
        getProviders: getProviders,
        saveProvider: saveProvider,
    }

    return service;

    function getProviders () {
        var deferred = $q.defer();
        $http.get('/api/providers', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getProvider (providerId) {
        var deferred = $q.defer();
        var url = '/api/provider/' + providerId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveProvider (provider) {
        var deferred = $q.defer();
        var url = '/api/provider';
        $http.post(url, provider).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteProvider (providerId) {
        var deferred = $q.defer();
        var url = '/api/provider/' + providerId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/provider.service.js